// extracted by mini-css-extract-plugin
var _1 = "alert__QoPIB";
var _2 = "mainButton__B0wNm";
var _3 = "outlined__sZBwk";
var _4 = "spinnerWrapper__UHiSC";
var _5 = "textWrapper__ivoEp";
export { _1 as "alert", _2 as "mainButton", _3 as "outlined", _4 as "spinnerWrapper", _5 as "textWrapper" }
export default { "alert": _1, "mainButton": _2, "outlined": _3, "spinnerWrapper": _4, "textWrapper": _5 }
